


























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Homepage extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() buttons!: {
    text: string;
    href: string;
  }[];
  @Prop() imageSrc!: string;
  @Prop({ default: false }) imageToRight!: boolean;
}
